import { useState, useEffect, useCallback, useRef } from "react";
import { CommissionStatus } from "../../ContractCommissions/constants";

export function useGetUnassignedChargebacks({
  api,
  payoutRunId,
  status = CommissionStatus.Approved,
  onError,
}) {
  const [chargebacks, setChargebacks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const apiRef = useRef(api);

  useEffect(() => {
    apiRef.current = api;
  }, [api]);

  const search = useCallback(
    async (term) => {
      const params = new URLSearchParams({ status, payoutRunId });
      if (term) params.set("contractNumber", term);

      setIsLoading(true);
      try {
        const response = await apiRef.current.get(
          `/api/commission/payout-runs/chargeback-record/unassigned?${params.toString()}`,
          { suppressGlobalError: true },
        );
        if (response.status === 200) {
          const data = Array.isArray(response.data)
            ? response.data
            : (response.data?.chargebackRecords ?? []);
          setChargebacks(
            data.map((record) => ({ ...record, recordType: "chargeback" })),
          );
        }
      } catch (error) {
        onError?.(error);
      } finally {
        setIsLoading(false);
      }
    },
    [payoutRunId, status],
  );

  return { chargebacks, isLoading, search };
}
